export default __webpack_public_path__ + "static/gaming_journey_3-9c119141d2acb5f0c752d760d5fcd8e2.jpg";